import { CssBaseline } from '@mui/material'
import { RouterProvider } from 'react-router-dom'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { DefaultOptions, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'dayjs/locale/ru'

import { AxiosError } from 'axios'
import { Provider } from 'react-redux'

import { store } from '@/stores'

import { router } from './router'
import { ThemeProvider } from './components/theme-provider'

const defaultQueryOptions: DefaultOptions<AxiosError> = {
  queries: {
    retry: (attemptIdx, error) => {
      if (attemptIdx > 3) {
        return false
      }
      return ![404, 403].includes(error?.response?.status ?? 0)
    },
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    gcTime: 1000 * 60 * 5,
    staleTime: 1000 * 60 * 5,
  },
}
const queryClient = new QueryClient({
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  defaultOptions: defaultQueryOptions,
})

function App() {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru" dateFormats={{ month: 'MMMM' }}>
          <ThemeProvider>
            <CssBaseline />
            <RouterProvider router={router} />
          </ThemeProvider>
        </LocalizationProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </Provider>
  )
}

export default App
